function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgArchiRepoLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 77 86",
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinejoin: "round",
      strokeMiterlimit: 2
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,-7.56983,-5.33276)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,-247.63,-161.767)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M321.1,169.8C325.7,169.8 329.4,173.5 329.4,178.1C329.4,181.3 327.6,184.1 325,185.5L325,234.3C327.5,235.7 329.1,238.4 329.1,241.5C329.1,246.1 325.4,249.8 320.8,249.8C316.2,249.8 312.5,246.1 312.5,241.5L312.5,241.4L270.4,217C269.2,217.7 267.8,218.1 266.2,218.1C261.6,218.1 257.9,214.4 257.9,209.8C257.9,205.2 261.6,201.5 266.2,201.5C267.7,201.5 269.1,201.9 270.3,202.6L312.8,177.9C312.9,173.4 316.6,169.8 321.1,169.8M321.1,167.1C315.6,167.1 311.1,171 310.2,176.3L270.2,199.5C268.9,199 267.6,198.8 266.2,198.8C260.1,198.8 255.2,203.8 255.2,209.8C255.2,215.8 260.2,220.8 266.2,220.8C267.6,220.8 269,220.5 270.2,220L309.8,242.9C310.5,248.3 315.2,252.4 320.7,252.4C326.8,252.4 331.7,247.4 331.7,241.4C331.7,238 330.1,234.9 327.6,232.8L327.6,187C330.4,184.9 332,181.7 332,178.2C332.2,172 327.2,167.1 321.1,167.1Z",
    style: {
      fill: "white",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,-247.63,-161.767)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M320.9,185.2L320.4,185.2C317.8,185.2 315.5,183.7 314.4,181.6L272.6,205.9C273.3,207 273.7,208.2 273.7,209.6C273.7,210.9 273.3,212.2 272.6,213.2L314.3,237.3C315.4,235 317.7,233.4 320.4,233.4L320.9,233.4L320.9,185.2Z",
    style: {
      fill: "white",
      fillRule: "nonzero"
    }
  }))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArchiRepoLogo);
export default __webpack_public_path__ + "static/media/ArchiREPO_logo.1bd2db76dc9e545608a503d5959e71b1.svg";
export { ForwardRef as ReactComponent };